import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './../../shared/pipes/safe-html.pipe';
import { FolderFilterPipe } from './../../shared/pipes/folder-filter.pipe';
import { MyFilterPipe } from './../../shared/pipes/my-filter.pipe';
import { FilterUniqueNamePipe } from './../../shared/pipes/unique-name.pipe';
import { TruncatePipe } from './../../shared/pipes/truncate.pipe';
import { ReversePipe } from './../../shared/pipes/reverse.pipe';
import { OrderByPipe } from './../../shared/pipes/order-by.pipe';
import { ConvertFrom24To12FormatPipe } from './../../shared/pipes/convert-from24-to12-format.pipe';
import { MailContentComponent } from '../mail-content/mail-content.component';
import { MailContentOldComponent } from '../mail-content-old/mail-content-old.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CustomInputComponent } from './../../shared/custom-input/custom-input.component';
import { BreadcrumbComponent } from './../../breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
	faSync,
	faMale,
	faFemale,
	faSquare,
	faCheckSquare,
	faMedkit,
	faAmbulance,
	faBrain,
	faShip,
	faHome,
	faPowerOff,
	faLock,
	faCloudDownloadAlt,
	faSpinner,
	faTh,
	faAngleDown,
	faAngleUp,
	faTimes,
	faUser,
	faUsers,
	faEnvelope,
	faBookMedical,
	faFileMedical,
	faFileMedicalAlt,
	faPumpMedical,
	faNotesMedical,
	faClinicMedical,
	faLaptopMedical,
	faCommentMedical,
	faBriefcaseMedical,
	faHandHoldingMedical,
	faCheck,
	faMinus,
	faFilter,
	faPlus,
	faPencilAlt,
	faTrash,
	faKey,
	faUserAlt,
	faUserPlus,
	faUserCircle,
	faCapsules,
	faTablet,
	faTablets,
	faTabletAlt,
	faSave,
	faSignOutAlt,
	faHelicopter,
	faBuilding,
	faFlag,
	faDatabase,
	faCity,
	faEye,
	faEyeSlash,
	faStar,
	faInfo,
	faInfoCircle,
	faChalkboard,
	faFileExcel,
	faFilePdf,
	faSearch,
	faRedo,
	faAngleDoubleRight,
	faFile,
	faCamera,
	faCameraRetro,
	faQuestionCircle,
	faEnvelopeOpen,
	faPaperPlane,
	faRupeeSign,
	faVideo,
	faTachometerAlt,
	faHospital,
	faUserMd,
	faCogs,
	faLanguage,
	faBalanceScale,
	faIndustry,
	faListAlt,
	faMoneyBill,
	faFileAlt,
	faQuestion,
	faImage,
	faList,
	faMicrophone,
	faMicrophoneSlash,
	faArrowRight,
	faArrowLeft,
	faVideoSlash,
	faComment,
	faPaperclip,
	faBan,
	faInbox,
	faEdit,
	faUnlink,
	faExclamationTriangle,
	faLink,
	faUndo,
	faReply,
	faFileUpload,
	faCloudUploadAlt,
	faTrashAlt,
	faTrashRestore,
	faTrashRestoreAlt,
	faTimesCircle,
	faBarcode,
	faDollarSign,
	faEnvelopeOpenText,
	faCalendarCheck,
	faCalendar,
	faCalendarAlt,
	faCalendarWeek,
	faCalendarDay,
	faCalendarPlus,
	faPaintBrush,
	faCircle,
	faSyncAlt,
	faLongArrowAltLeft,
	faLongArrowAltRight,
	faPhone,
	faCopy,
	faExternalLinkAlt
} from '@fortawesome/free-solid-svg-icons';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatetimepickerModule, MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { NgbModule, NgbDatepickerModule, NgbTimepickerModule, NgbDateNativeAdapter, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DataTablesModule } from 'angular-datatables';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxFileDropModule } from 'ngx-file-drop';
import { QuillModule } from 'ngx-quill';
/* import { AngularFireModule } from '@angular/fire/compat'; */
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { environment } from '../../../environments/environment';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { TagInputModule } from 'ngx-chips';
import { ClinicFormComponent } from '../../masters/clinic/clinic-form/clinic-form.component';
import { LimitToPipe } from '../../shared/pipes/limit-to.pipe';
import { LimitToComponent } from '../limit-to/limit-to.component';
import { DoctorFormComponent } from '../../masters/doctor/doctor-form/doctor-form.component';
import { QuestionFormComponent } from '../../masters/questionbank/question-form/question-form.component';
import { ProfileFormComponent } from '../../masters/profile/profile-form/profile-form.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { LanguageFormComponent } from '../../masters/language/language-form/language-form.component';
import { ScaleFormComponent } from '../../masters/scale/scale-form/scale-form.component';
import { BranchFormComponent } from '../../masters/branch/branch-form/branch-form.component';
import { RankCategoryFormComponent } from '../../masters/rank-category/rank-category-form/rank-category-form.component';
import { ReportTemplateFormComponent } from '../../masters/report-template/report-template-form/report-template-form.component';
import { VideocallLanguageFormComponent } from '../../masters/videocall-language/videocall-language-form/videocall-language-form.component';
import { CurrencyFormComponent } from '../../masters/currency/currency-form/currency-form.component';
import { ReportTextFormComponent } from '../../masters/report-text/report-text-form/report-text-form.component';
import { VesselFormComponent } from '../../masters/vessel/vessel-form/vessel-form.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BlankTopbarComponent } from '../../policies/blank-topbar/blank-topbar.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ViewAttachmentsComponent } from '../../mailbox/view-attachments/view-attachments.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { MailDisplayComponent } from '../mail-display/mail-display.component';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
import { MailFormComponent } from '../../mailbox/mail-form/mail-form.component';

@NgModule({
	declarations: [
		SafeHtmlPipe,
		FolderFilterPipe,
		TruncatePipe,
		MyFilterPipe,
		ReversePipe,
		FilterUniqueNamePipe,
		OrderByPipe,
		ConvertFrom24To12FormatPipe,
		MailContentComponent,
		MailContentOldComponent,
		CustomInputComponent,
		BreadcrumbComponent,
		ClinicFormComponent,
		LimitToPipe,
		LimitToComponent,
		DoctorFormComponent,
		QuestionFormComponent,
		ProfileFormComponent,
		LanguageFormComponent,
		ScaleFormComponent,
		BranchFormComponent,
		RankCategoryFormComponent,
		ReportTemplateFormComponent,
		VideocallLanguageFormComponent,
		CurrencyFormComponent,
		ReportTextFormComponent,
		VesselFormComponent,
		BlankTopbarComponent,
		ViewAttachmentsComponent,
		MailDisplayComponent,
		FileUploaderComponent,
		MailFormComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		MatFormFieldModule,
		RouterModule,
		FontAwesomeModule,
		MatInputModule,
		MatProgressBarModule,
		ReactiveFormsModule,
		HttpClientModule,
		ToastrModule.forRoot(),
		MatRadioModule,
		MatAutocompleteModule,
		NgbModule,
		MatDatepickerModule,
		MatDatetimepickerModule,
		MatNativeDateModule,
		MatNativeDatetimeModule,
		MatTooltipModule,
		MatExpansionModule,
		MatCardModule,
		MatIconModule,
		MatDividerModule,
		MatButtonModule,
		MatSlideToggleModule,
		MatSelectModule,
		MatTableModule,
		MatProgressSpinnerModule,
		DataTablesModule,
		NgToggleModule,
		MatButtonToggleModule,
		MatToolbarModule,
		NgSelectModule,
		MatCheckboxModule,
		NgxFileDropModule,
		QuillModule.forRoot(),
		MatMenuModule,
		NgxChartsModule,
		MatPaginatorModule,
		MatGridListModule,
		NgbDatepickerModule,
		NgbTimepickerModule,
		MatChipsModule,
		/* AngularFireModule.initializeApp(environment.firebaseConfig), */
		provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
		provideFirestore(() => getFirestore()),
		provideAuth(() => getAuth()),
		provideMessaging(() => getMessaging()),
		AutocompleteLibModule,
		TagInputModule,
		ImageCropperComponent,
		ScrollingModule,
		CalendarModule.forRoot({
			provide: DateAdapter,
			useFactory: adapterFactory,
		}),
		ColorPickerModule,
		NgbModalModule
	],
	exports: [
		SafeHtmlPipe,
		FolderFilterPipe,
		TruncatePipe,
		MyFilterPipe,
		ReversePipe,
		FilterUniqueNamePipe,
		OrderByPipe,
		ConvertFrom24To12FormatPipe,
		MailContentComponent,
		MailContentOldComponent,
		MatFormFieldModule,
		CustomInputComponent,
		BreadcrumbComponent,
		RouterModule,
		FontAwesomeModule,
		MatInputModule,
		MatProgressBarModule,
		ReactiveFormsModule,
		FormsModule,
		HttpClientModule,
		ToastrModule,
		MatRadioModule,
		MatAutocompleteModule,
		NgbModule,
		MatDatepickerModule,
		MatDatetimepickerModule,
		MatNativeDateModule,
		MatNativeDatetimeModule,
		MatTooltipModule,
		MatExpansionModule,
		MatCardModule,
		MatIconModule,
		MatDividerModule,
		MatButtonModule,
		MatSlideToggleModule,
		MatSelectModule,
		MatTableModule,
		MatProgressSpinnerModule,
		DataTablesModule,
		NgToggleModule,
		MatButtonToggleModule,
		MatToolbarModule,
		NgSelectModule,
		MatCheckboxModule,
		NgxFileDropModule,
		QuillModule,
		MatMenuModule,
		NgxChartsModule,
		MatPaginatorModule,
		MatGridListModule,
		NgbDatepickerModule,
		NgbTimepickerModule,
		MatChipsModule,
		AutocompleteLibModule,
		TagInputModule,
		ClinicFormComponent,
		LimitToPipe,
		LimitToComponent,
		DoctorFormComponent,
		QuestionFormComponent,
		ProfileFormComponent,
		ImageCropperComponent,
		LanguageFormComponent,
		ScaleFormComponent,
		BranchFormComponent,
		RankCategoryFormComponent,
		ReportTemplateFormComponent,
		VideocallLanguageFormComponent,
		CurrencyFormComponent,
		ReportTextFormComponent,
		VesselFormComponent,
		BlankTopbarComponent,
		ScrollingModule,
		CalendarModule,
		ViewAttachmentsComponent,
		ColorPickerModule,
		NgbModalModule,
		MailDisplayComponent,
		FileUploaderComponent,
		MailFormComponent
	],
	providers: [
		{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
		/* { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter } */
	],
})
export class CommonImportsModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(
			faUserPlus,
			faUserCircle,
			faSync,
			faMale,
			faFemale,
			faSquare,
			faCheckSquare,
			faMedkit,
			faAmbulance,
			faBrain,
			faShip,
			faHome,
			faPowerOff,
			faLock,
			faCloudDownloadAlt,
			faSpinner,
			faTh,
			faAngleDown,
			faAngleUp,
			faTimes,
			faUser,
			faUsers,
			faUserAlt,
			faEnvelope,
			faBookMedical,
			faFileMedical,
			faMedkit,
			faFileMedicalAlt,
			faPumpMedical,
			faNotesMedical,
			faClinicMedical,
			faLaptopMedical,
			faCommentMedical,
			faBriefcaseMedical,
			faHandHoldingMedical,
			faCheck,
			faMinus,
			faFilter,
			faPlus,
			faPencilAlt,
			faTrash,
			faLock,
			faKey,
			faCapsules,
			faTablet,
			faTablets,
			faTabletAlt,
			faSave,
			faSignOutAlt,
			faHelicopter,
			faBuilding,
			faFlag,
			faDatabase,
			faCity,
			faEye,
			faEyeSlash,
			faStar,
			faInfo,
			faInfoCircle,
			faChalkboard,
			faFileExcel,
			faFilePdf,
			faSearch,
			faRedo,
			faAngleDoubleRight,
			faFile,
			faPencilAlt,
			faCamera,
			faCameraRetro,
			faEnvelopeOpen,
			faEnvelope,
			faPaperPlane,
			faRupeeSign,
			faVideo,
			faTachometerAlt,
			faHospital,
			faUserMd,
			faUserPlus,
			faCogs,
			faLanguage,
			faBalanceScale,
			faIndustry,
			faListAlt,
			faMoneyBill,
			faFileAlt,
			faQuestion,
			faPencilAlt,
			faImage,
			faList,
			faMicrophone,
			faMicrophoneSlash,
			faArrowRight,
			faArrowLeft,
			faVideoSlash,
			faQuestionCircle,
			faComment,
			faPaperclip,
			faBan,
			faInbox,
			faEdit,
			faPaperPlane,
			faUnlink,
			faLink,
			faExclamationTriangle,
			faUndo,
			faReply,
			faFileUpload,
			faCloudUploadAlt,
			faTrashAlt,
			faTrashRestore,
			faTrashRestoreAlt,
			faTimesCircle,
			faBarcode,
			faDollarSign,
			faEnvelopeOpenText,
			faCalendarAlt,
			faCalendarWeek,
			faCalendar,
			faCalendarCheck,
			faCalendarDay,
			faCalendarPlus,
			faPaintBrush,
			faCircle,
			faSync,
			faSyncAlt,
			faLongArrowAltLeft,
			faLongArrowAltRight,
			faPhone,
			faCopy,
			faExternalLinkAlt
		);
	}
}
